import { render, staticRenderFns } from "./profitSharing.vue?vue&type=template&id=c3b3d390&scoped=true"
import script from "./profitSharing.vue?vue&type=script&lang=js"
export * from "./profitSharing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b3d390",
  null
  
)

export default component.exports